export var AccessType;
(function (AccessType) {
    AccessType["Paying"] = "PAYING";
    AccessType["Evaluation"] = "EVALUATION";
    AccessType["Internal"] = "INTERNAL";
    AccessType["Demo"] = "DEMO";
    AccessType["CustomAgreement"] = "CUSTOM_AGREEMENT";
})(AccessType || (AccessType = {}));
export var CustomerType;
(function (CustomerType) {
    CustomerType["ApiOnly"] = "API ONLY";
    CustomerType["Distributor"] = "DISTRIBUTOR";
    CustomerType["DistributorsCustomer"] = "DISTRIBUTOR'S CUSTOMER";
    CustomerType["RegularCustomer"] = "REGULAR CUSTOMER";
})(CustomerType || (CustomerType = {}));
export var ProductType;
(function (ProductType) {
    ProductType["PortalOnly"] = "PORTAL_ONLY";
    ProductType["PortalWithApi"] = "PORTAL_WITH_API";
})(ProductType || (ProductType = {}));
export var UserPricing;
(function (UserPricing) {
    UserPricing["NetworkPackages"] = "NETWORK_PACKAGES";
    UserPricing["OldNetworkModel"] = "OLD_NETWORK_MODEL";
})(UserPricing || (UserPricing = {}));
export var UserType;
(function (UserType) {
    UserType["ApiOnly"] = "API_ONLY";
    UserType["Portal"] = "PORTAL";
})(UserType || (UserType = {}));
export var LimitType;
(function (LimitType) {
    LimitType["Boolean"] = "BOOLEAN";
    LimitType["Count"] = "COUNT";
    LimitType["Date"] = "DATE";
    LimitType["DateRange"] = "DATE_RANGE";
    LimitType["Km"] = "KM";
    LimitType["Geo"] = "GEO";
    LimitType["SquareKm"] = "SQUARE_KM";
    LimitType["Select"] = "SELECT";
    LimitType["MultiSelect"] = "MULTISELECT";
    LimitType["MortonIds"] = "MORTON_IDS";
})(LimitType || (LimitType = {}));
export function isMeDetails(meDetails) {
    return !("isFallback" in meDetails);
}
export function isMeDetailsFallback(meDetails) {
    return meDetails.isFallback === true;
}
export function isUserProduct(product) {
    return !("isFallback" in product);
}
export function isUserProductFallback(product) {
    return product.isFallback === true;
}
//# sourceMappingURL=legolandApiTypes.js.map